<template>
  <el-scrollbar class="crm-follow">
    <el-timeline v-infinite-scroll="getList" :infinite-scroll-disabled="disabled" style="padding-right: 15px;">
      <el-timeline-item v-for="(item,index1) in list" :key="index1" :timestamp="item.createTime" placement="top" color="#409EFF">
        <el-button type="text" class="followDeleteClass" @click="deleteFollow('deleteFollow', item.id,null)">删除</el-button>
        <el-button type="text" class="followReplyClass" @click="showReplyModel(item)">回复</el-button>
        <el-card>
          <div  class="content">
            <div v-if="getStageLabel(item)" class="stageCodeDesc">{{getStageLabel(item)}}</div>
            <span>{{item.followerName}}{{" "}}</span>
            <span v-if="shouldHideCurrentTargetInfo(item)">
              {{ item.followTypeDesc || '跟进' }}
            </span>
            <span v-else-if="item.followType !== 'completePlan'"><span>{{item.followTypeDesc}}</span>跟进了<span>{{item.targetTypeDesc}}</span></span>
            <span v-if="!shouldHideCurrentTargetInfo(item) && item.followType !== 'completePlan' && item.targetType !== 'clue'">
              <span>：</span>
              <span v-if="targetId === item.targetId && targetType === item.targetType">{{ item.targetName }}</span>
              <el-link
                v-else
                type="primary"
                :underline="false"
                @click="toDetail(item.targetId, item.targetType)">
              {{ item.targetName }}
            </el-link>
            </span>
          </div>
          <div>
            <span class="content">{{item.followSubTypeDesc}}</span>
          </div>
          <div v-if="item.followContactName" class="content" style="margin-top: 5px">联系人：
            <el-link type="primary" :underline="false" @click="toContactDetail(item.followContactId)">
              {{ item.followContactName }}
            </el-link>
          </div>
          <div v-if="item.displayContent || item.displayFileText" class="content" style="margin-top: 10px">{{item.displayContent || item.displayFileText}}</div>
          <FileUpload v-model="item.fileObjs" :readOnly="true"></FileUpload>
          <!--跟进的回复列表-->
          <el-card v-if="item.followReplyList" class="reply-card" shadow="never"
                   v-for="(reply,index2) in item.followReplyList" :key="index2">
            <div>
              <span style="color: #9ea1a7">{{reply.createTime}}</span>
              <el-button type="text" class="replyClass" @click="showReplyModel(reply)">回复</el-button>
              <el-button type="text" class="deleteReplyClass" @click="deleteFollow('deleteReply', item.id, reply.id)">删除</el-button>
            </div>
            <div style="margin-top: 8px">{{reply.replyUserName}} 回复 {{reply.replyTargetUserName}}</div>
            <div style="margin-top: 8px">{{reply.plainContent || reply.replyContent}}</div>
          </el-card>
        </el-card>
      </el-timeline-item>
    </el-timeline>
    <p v-if="loading" class="tip">加载中...</p>
    <p v-if="noMore && (!hideEmptyTip || list.length > 0)" class="tip">{{list.length > 0 ? "没有更多了" : "暂无数据"}}</p>
    <el-dialog title="回复跟进" :visible.sync="replyVisible" width="500px" :close-on-click-modal="false" :append-to-body="true">
      <el-form ref="replyForm" :model="replyForm" :rules="replyRules">
        <el-form-item label="" prop="replyContent">
          <el-input type="textarea" maxlength="1000" :autosize="{ minRows: 4 }" show-word-limit
                    placeholder="请输入内容" v-model="replyForm.replyContent"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="replyVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmReply">确认</el-button>
      </div>
    </el-dialog>
  </el-scrollbar>
</template>

<script>
import {createFollowReply, deleteFollowReply, listFollowByTarget, queryFollowReplyList} from "@/api/crm/follow";
import FileUpload from "@/views/crm/components/fileUpload";
import {businessTargetTypeToPath} from "@/utils/crm";

export default {
  name: "followList",
  props: {
    targetId: {},
    targetType: {},
    targetTypeFilter: {
      type: String,
      default: ''
    },
    contractPhaseId: {
      default: null
    },
    hideEmptyTip: {
      type: Boolean,
      default: false
    },
    hideCurrentTargetInfo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      noMore: false,
      list: [],
      dialogImageUrl: '',
      dialogVisible: false,
      // 查询参数
      queryParams: {
        pageNum: 0,
        pageSize: 10,
        targetId: null,
        targetType: null,
        contractPhaseId: null
      },
      replyVisible: false,
      replyTarget: null,
      replyForm: {
        replyContent: ''
      },
      replyRules: {
        replyContent: [
          {required: true, message: '内容不能为空', trigger: 'change'}
        ]
      }
    };
  },
  created() {
    console.log("created")
    this.queryParams.targetId = this.targetId;
    this.queryParams.targetType = this.targetType;
    this.queryParams.contractPhaseId = this.contractPhaseId;
    this.refresh();
  },
  components: {
    FileUpload
  },
  watch: {
    targetId (val) {
      console.log("targetId watch", val)
      if (val !== this.queryParams.targetId) {
        this.queryParams.targetId = val;
        this.refresh();
      }
    },
    targetType (val) {
      console.log("targetType watch", val)
      if (val !== this.queryParams.targetType) {
        this.queryParams.targetType = val;
        this.refresh();
      }
    },
    targetTypeFilter(val) {
      console.log("targetType watch", val)
      this.refresh();
    },
    contractPhaseId (val) {
      if (val !== this.queryParams.contractPhaseId) {
        this.queryParams.contractPhaseId = val;
        this.refresh();
      }
    },
  },
  computed: {
    disabled () {
      return this.loading || this.noMore
    }
  },
  methods: {
    notifyListChange() {
      this.$emit('list-change', {
        count: this.list.length,
        loading: this.loading,
        noMore: this.noMore
      })
    },
    isCurrentTarget(item) {
      return String(this.targetId) === String(item.targetId) && this.targetType === item.targetType
    },
    shouldHideCurrentTargetInfo(item) {
      return this.hideCurrentTargetInfo && this.isCurrentTarget(item)
    },
    getStageLabel(item) {
      if (!item) {
        return ''
      }
      if (item.contractPhaseId || item.contractPhaseName || item.followType === '阶段进展') {
        return item.contractPhaseName || '阶段进展'
      }
      return item.businessStageCodeDesc || ''
    },
    resolveFollowContent(item) {
      const candidates = [
        item && item.plainContent,
        item && item.followPlainContent,
        item && item.contentText,
        item && item.originalContent,
        item && item.content,
        item && item.followContent,
        item && item.remark
      ]
      for (let index = 0; index < candidates.length; index++) {
        const text = this.normalizeFollowContent(candidates[index])
        if (text) {
          return text
        }
      }
      return ''
    },
    normalizeFollowContent(value) {
      if (value === undefined || value === null) {
        return ''
      }
      const raw = String(value).trim()
      if (!raw || raw === '[]') {
        return ''
      }
      if (!raw.startsWith('[')) {
        return raw
      }
      try {
        const list = JSON.parse(raw)
        if (!Array.isArray(list)) {
          return raw
        }
        return list.map(item => {
          if (!item) {
            return ''
          }
          if (item.type === 1 && item.atUser) {
            return `@${item.atUser.nickName || item.atUser.userName || item.atUser.name || ''} `
          }
          return item.content || item.text || ''
        }).join('').trim()
      } catch (e) {
        return raw
      }
    },
    resolveFollowFileText(item) {
      const files = this.normalizeFollowFiles(item && (item.fileObjs || item.files || item.fileList || item.attachments))
      return files.length ? `已上传附件 ${files.length} 个` : ''
    },
    normalizeFollowFiles(value) {
      if (!value) {
        return []
      }
      if (Array.isArray(value)) {
        return value.filter(Boolean)
      }
      if (typeof value === 'string') {
        const text = value.trim()
        if (!text) {
          return []
        }
        if (text.startsWith('[') || text.startsWith('{')) {
          try {
            const parsed = JSON.parse(text)
            return Array.isArray(parsed) ? parsed.filter(Boolean) : [parsed]
          } catch (e) {
            return []
          }
        }
      }
      if (typeof value === 'object') {
        return [value]
      }
      return []
    },
    getList() {
      if (!this.queryParams.targetId || !this.queryParams.targetType) {
        return;
      }
      this.loading = true
      this.notifyListChange()
      this.queryParams.pageNum++
      listFollowByTarget({
        ...this.queryParams,
        targetTypeFilter: this.targetTypeFilter
      }).then(response => {
        let { rows } = response
        if (rows && rows.length) {
          rows.map(item => {
            item.displayContent = this.resolveFollowContent(item)
            item.displayFileText = this.resolveFollowFileText(item)
            if (item.contentType == 2) {
              try {
                item.contentToJSON = JSON.parse(item.content)
              } catch (e) {
                item.contentToJSON = []
              }
            }
            return item
          })
        }
        this.list = this.list.concat(rows || [])
        if (!response.hasNext) {
          // 查完了
          this.noMore = true
        }
        this.loading = false
        this.notifyListChange()
      }).catch(error => {
        this.loading = false
        this.noMore = true
        this.notifyListChange()
      });
    },
    refresh () {
      console.log("follow list refresh")
      if (!this.queryParams.targetId || !this.queryParams.targetType) {
        return;
      }
      this.queryParams.pageNum = 0
      this.noMore = false
      this.list = []
      this.notifyListChange()
      this.getList()
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
      window.open(file.url)
    },
    /** 详细按钮操作 */
    toDetail(targetId, targetType) {
      window.open("/crm/" + businessTargetTypeToPath(targetType) + "/detail/" + targetId, "_blank")
    },
    toContactDetail(followContactId) {
      window.open("/crm/contact/detail/" + followContactId, "_blank")
    },
    deleteFollow (optType, followId, replyId) {
      this.$confirm('请确认是否删除该记录', "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let param;
        if (optType === 'deleteFollow') {
          param = {followId: followId}
        } else if (optType === 'deleteReply'){
          param = {replyId: replyId}
        } else {
          return
        }
        deleteFollowReply(param).then(response => {
          this.msgSuccess("操作成功");
          if (optType === 'deleteFollow') {
            // 刷新跟进列表
            this.list.find((item, index) => {
              if (item.id === followId) {
                this.list.splice(index,1);
                this.notifyListChange()
                return true
              }
            })
          } else {
            // 刷新本跟进的回复列表
            queryFollowReplyList({'followId': followId}).then(response => {
              this.list.find(item => {
                if (item.id === followId) {
                  item.followReplyList = response.data
                  return true
                }
              })
            })
          }
        });
      })
    },
    showReplyModel (item) {
      console.log('item=' + JSON.stringify(item))
      this.replyTarget = item
      if (this.$refs['replyForm'] !== undefined) {
        this.$refs['replyForm'].resetFields();
      }
      this.replyVisible = true
    },
    confirmReply () {
      this.$refs['replyForm'].validate((valid) => {
        if (valid) {
          // 有replyTargetUserId字段的则为回复回复，否则为回复跟进
          if (this.replyTarget.replyTargetUserId) {
            this.replyForm.followId = this.replyTarget.followId
          } else {
            this.replyForm.followId = this.replyTarget.id
          }
          this.replyForm.replyTargetUserId = this.replyTarget.createBy
          console.log('this.replyForm=' + JSON.stringify(this.replyForm))

          createFollowReply(this.replyForm).then(response => {
            this.msgSuccess("回复成功");
            // 刷新跟进回复列表
            queryFollowReplyList({'followId': this.replyForm.followId}).then(response => {
              this.list.find(item => {
                if (item.id === this.replyForm.followId) {
                  item.followReplyList = response.data
                  return true
                }
              })
            })
            this.replyVisible = false
          }).finally(() => this.loading = false);
        }
      })
    }
  }
};
</script>

<style lang='scss'>
.el-scrollbar {
  height: 100%;
}
.crm-follow {
  .content {
    word-break: break-all;
    line-height: 1.5em;
    .el-link{
      vertical-align: top;
      height: 16px;
      margin-top: 1px;
    }
    .nameStyle {
      color: #4480f3;
    }
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .tip{
    text-align: center;
    color: #909399;
    font-size: 14px;
  }
  .follow-show-files{
    .el-upload--picture-card{
      display: none;
    }
    .el-upload-list__item{
      width: 100px;
      height: 100px;
    }
    .follow-image{
      width: 100px;
      height: 100px;
    }
    .follow-doc{
      text-align: center;
      .follow-doc-icon{
        font-size: 30px;
        padding-top: 15px;
      }
      .follow-doc-name{
        font-weight:500;
        font-size: 12px;
        word-break: break-all;
      }
    }
  }
  .followReplyClass {
    position: absolute;
    right: 18px;
    top: -8px;
  }

  .followDeleteClass {
    position: absolute;
    right: 68px;
    top: -8px;
  }
  .replyClass {
    float: right;
    padding: 0;
  }
  .deleteReplyClass {
    float: right;
    padding: 0;
    margin-right: 20px;
  }
  .reply-card {
    background-color: #efefef;
    border-width: 0;
    margin-top: 10px;
  }
  .stageCodeDesc {
    float: right;
    padding: 0;
    color: #9ea1a7;
  }
}
</style>
